import React, { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Container, Grid } from '@mui/material'
import professionalData from '../data/professional.json'

const Professional = ( { view } ) => {
    const targetRef = useRef( null )
    const { scrollYProgress } = useScroll( {
        target: targetRef,
        offset: ['start end', 'end start'],
    } )

    const left = useTransform( scrollYProgress, view === 'web' ? [0., 0.5] : [0, 0.38], view === 'web' ? ['240px', '0px'] : ['250px', '0px'] )
    const right = useTransform( scrollYProgress, view === 'web' ? [0., 0.5] : [0, 0.38], view === 'web' ? ['240px', '0px'] : ['250px', '0px'] )
    const bottom = useTransform( scrollYProgress, view === 'web' ? [0., 0.4] : [0, 0.35], view === 'web' ? ['100px', '0px'] : ['70px', '0px'] )

    const animationOrder = [ 'right', 'left', 'right', 'left', 'right', 'left', 'right' ]

    return (
        <div
            ref={ targetRef }
            className="experience"
            style={ {
                marginBlockStart: "20px",
                paddingBlockEnd: "30px",
                paddingBlockStart: "50px",

            } }>
            <motion.div style={ { bottom, position: 'relative' } } className="profTitle">Professional Experience</motion.div>
            <Container className="max124">
                { professionalData.map( ( experience, index ) => (
                    <motion.div
                        key={ experience.id }
                        style={ {
                            position: 'relative',
                            [animationOrder[index]]: animationOrder[index] === 'left' ? left : right,
                        } }
                    >
                        <Accordion sx={ index >= 1 && index < professionalData.length - 1 ? { marginBlock: "10px" } : {} }>
                            <AccordionSummary
                                expandIcon={ <ExpandMoreIcon /> }
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                sx={ { backgroundColor: "#eeeeee" } }
                            >
                                <h2 className="accorTitle">
                                    { experience.title }
                                </h2>
                            </AccordionSummary>
                            <AccordionDetails className="accordDet">
                                <Grid container>
                                    <Grid item xs={ 9 } sx={ { textAlign: "left" } }>
                                        <div className="descExp">
                                            { experience.description }
                                        </div>
                                        <div className="techStack">
                                            { experience.techStack.map( ( item, techIndex ) => (
                                                <div
                                                    className="tech"
                                                    style={ {
                                                        display: experience.techStackHideIndex === techIndex ? "none" : "",
                                                    } }
                                                    key={ techIndex }
                                                >
                                                    { item }
                                                </div>
                                            ) ) }
                                        </div>
                                    </Grid>
                                    <Grid item xs={ 3 } className="selfCenter">
                                        <img
                                            src={ experience.logoUrl }
                                            alt={ experience.logoAlt }
                                            style={ { maxWidth: '182px' } }
                                            className="logoWall"
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </motion.div>
                ) ) }
            </Container>
        </div>

    )
}

export default Professional
